import ToggleEnquiryFormButton from '@bridebook/web/app-basic/components/supplier/toggle-enquiry-form-button';
import { getSupplierGenericProperties } from '@bridebook/web/app-basic/lib/analytics/helper';
import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import { getIsMobile } from '@bridebook/web/app-basic/lib/app/selectors';
import { getSupplier, getSupplierTier } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@bridebook/ui';
import SocialComp from '@bridebook/web/app-basic/components/supplier/sections/location-contact-details/social';

export const Social = () => {
  const isMobile = useSelector(getIsMobile);
  const supplier = useSelector(getSupplier);
  const dispatch = useDispatch();
  const supplierTier = useSelector(getSupplierTier);
  const supplierGenericProps = useMemo(
    () => getSupplierGenericProperties({ supplier, supplierTier }),
    [supplier, supplierTier],
  );

  const loggedOutAnalytics = useCallback(
    (cta: string) => {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'supplierProfile',
          clickedSection: 'supplierSocialMedia',
          cta,
          ...supplierGenericProps,
        }),
      );
    },
    [dispatch, supplierGenericProps],
  );

  if (!supplier) return null;

  return (
    <Box pb={6}>
      <SocialComp supplier={supplier} onSocialMediaClick={loggedOutAnalytics} />
      <Box alignItems="center" pt={isMobile ? 0 : 2}>
        <ToggleEnquiryFormButton fixedWidth={343} contactMethod="supplierProfile_location" />
      </Box>
    </Box>
  );
};
